import React, { Component } from "react";
import Logo from "../assets/images/logos/elan-row.png";
import {Nav, NavLink, Bars, NavMenu, Cross} from "./NavbarElements";
import {withUserContext} from "../components/ModalContext";

class Header extends Component {
    state = {
        sidebarOpened: false,
    };

    toggleSidebar = () =>
        this.setState({ sidebarOpened: !this.state.sidebarOpened });
    closeSidebar = () => this.setState({ sidebarOpened: false });

    getPageColor = () => {
        return window.location.pathname.substr(1);
    };

    render() {
        return (
            <div
                id={"navbar"}
                className={`navbar-container merch-header ${this.getPageColor()}-page`}
            >
                <Nav>
                    <NavLink onClick={this.closeSidebar} className={"logo-link"} to="/">
                        <img src={Logo} className={"navbar-logo"} alt="logo" />
                    </NavLink>

                    {/*<a style={{float:'right'}} onClick={this.closeSidebar} className={'external-link'}  href={'#'}>*/}
                    {/*    /!*<img src={Logo} className={"navbar-logo"} alt="logo" />*!/*/}
                    {/*    LOGO*/}
                    {/*</a>*/}
                    {/*{this.state.sidebarOpened ? <Cross*/}
                    {/*    className={`toggle-btn ${this.state.sidebarOpened ? "active" : ""}`}*/}
                    {/*    //style={{display:`${this.state.sidebarOpened ? 'block' : 'none'}`}}*/}
                    {/*    onClick={this.toggleSidebar}*/}
                    {/*/> : <Bars*/}
                    {/*    className={`toggle-btn ${this.state.sidebarOpened ? "active" : ""}`}*/}
                    {/*    //style={{display:`${this.state.sidebarOpened ? 'none' :'block' }`}}*/}
                    {/*    onClick={this.toggleSidebar}*/}
                    {/*/>}*/}

                    {/*<NavMenu*/}
                    {/*    className={`nav-menu ${this.state.sidebarOpened ? "active" : ""}`}*/}
                    {/*>*/}
                    {/*    <NavLink onClick={this.closeSidebar} to="/events" activeStyle>*/}
                    {/*        EVENTS*/}
                    {/*    </NavLink>*/}
                    {/*    <NavLink onClick={this.closeSidebar} to="/competitions" activeStyle>*/}
                    {/*        COMPETITIONS*/}
                    {/*    </NavLink>*/}
                    {/*    <a className={"external-link"} target={'_blank'} href="https://ca.elan.org.in/">*/}
                    {/*        CAMPUS AMBASSADOR*/}
                    {/*    </a>*/}
                    {/*    <NavLink onClick={this.closeSidebar} to="/team" activeStyle>*/}
                    {/*        TEAM*/}
                    {/*    </NavLink>*/}
                    {/*    <NavLink onClick={this.closeSidebar} to="/social-cause" activeStyle>*/}
                    {/*        SOCIAL CAUSE*/}
                    {/*    </NavLink>*/}
                    {/*    <NavLink onClick={this.closeSidebar} to="/sponsors" activeStyle>*/}
                    {/*        SPONSORS*/}
                    {/*    </NavLink>*/}
                    {/*    <NavLink onClick={this.closeSidebar} to="/contact" activeStyle>*/}
                    {/*        CONTACT US*/}
                    {/*    </NavLink>*/}
                    {/*    <a className={'external-link'} onClick={()=>{*/}
                    {/*        this.closeSidebar();*/}
                    {/*        this.props.setShow(true);*/}
                    {/*    }} style={{display:this.state.sidebarOpened ? 'block' :'none',background:'transparent'}} >*/}
                    {/*        REGISTER*/}
                    {/*    </a>*/}

                    {/*    <a className={'external-link'} href={"https://docs.google.com/document/d/1p4QXrOjeIueYTPP9_FbplPPPJTydTheFxC9WAX4qYKc/edit?usp=drivesdk"}*/}
                    {/*       onClick={this.closeSidebar} style={{display:this.state.sidebarOpened ? 'block' :'none'}} >*/}
                    {/*        FAQs*/}
                    {/*    </a>*/}
                    {/*</NavMenu>*/}

                </Nav>
            </div>
        );
    }
}

export default withUserContext(Header);


